import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import { PrimaryButton } from "../../../atoms/Buttons";
import ActionPageHero from "../../../molecules/ActionPageHero";

import notSearchedImg from "../../../../assets/images/Curly Arrow.svg";
import { H3, P } from "../../../atoms/Texts";
import { ReferralFormCard } from "../../../atoms/Cards";
import { DarkFormField } from "../../../atoms/Inputs";
import ReferralFormShareLinkModal from "../../../organisms/ReferralFormShareLinkModal";
import ReferralCopyCodeModal from "../../../organisms/ReferralCopyCodeModal";

import { demoContext } from "../../../../shared/store/contexts";

const AllReferralFormsPage = () => {
  const { id } = useParams();

  const [forms] = useState([]);

  const { register, watch } = useForm({
    defaultValues: {
      query: "",
    },
  });
  const [modalStates, setModalStates] = useState({
    shareLink: false,
    copyCode: false,
    createFormSuccess: false,
  });

  const [selectedFormURL, setSelectedFormURL] = useState(null);

  const { referralForms } = useContext(demoContext);

  return (
    <main className="flex flex-col w-full">
      <ActionPageHero
        className="organization-container"
        title="Referral Forms"
        description="Manage your referral forms"
        action
        actionComponent={
          <Link to={`/dashboard/organization/${id}/referral-forms/add`}>
            <PrimaryButton>Create Form</PrimaryButton>
          </Link>
        }
      />
      <section className="organization-container pb-10 flex-grow flex flex-col mt-6">
        <form className="md:w-3/5 mb-8">
          <div className="flex flex-wrap lg:flex-no-wrap">
            <div className="w-full flex-grow">
              <DarkFormField
                type="search"
                id="query"
                name="query"
                className="py-1 flex w-full"
                placeholder="Search by service name"
                iconBeforeClass=""
                data_testid="query-input"
                {...register("query")}
              />
            </div>
            <div className="md:ml-4">
              <PrimaryButton>Search</PrimaryButton>
            </div>
          </div>
        </form>

        <div className="">
          {referralForms.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 w-10/12">
              {referralForms.map((form) => (
                <ReferralFormCard
                  key={form.id}
                  form={form}
                  modalStates={modalStates}
                  setModalStates={setModalStates}
                  setSelectedFormURL={setSelectedFormURL}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-12">
              <img src={notSearchedImg} alt="" className="mb-4" />
              <H3 color="#22202D" className="mt-6" data-testid="forms-text">
                {watch("query") ? "No matches found" : "No forms have been added"}
              </H3>
              <P
                fontSize="16px"
                color="#7D7B96"
                className="mt-3 mb-0 text-center w-1/3"
              >
                {watch("query") ? "Try another search." : "Add a form now."}
              </P>
            </div>
          )}
        </div>
      </section>

      {modalStates?.shareLink && (
        <ReferralFormShareLinkModal
          closeModal={() => {
            setSelectedFormURL(null);
            setModalStates({ ...modalStates, shareLink: false });
          }}
          link={selectedFormURL}
        />
      )}

      {modalStates?.copyCode && (
        <ReferralCopyCodeModal
          closeModal={() => {
            setSelectedFormURL(null);
            setModalStates({ ...modalStates, copyCode: false });
          }}
          link={selectedFormURL}
        />
      )}
    </main>
  );
};

export default AllReferralFormsPage;
